import axios from "axios";
import { Urls } from "../../slices/urls";
import {ServiceUrls} from '../../serviceUrl'

// POST IDP REPO
export const postIdpRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_ENGINEERING_API,
    data: data,
  });
};

//POST_IDP_IMS_PUSH_API
export const postImsPushRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_IMS_PUSH_API,
    data: data,
  });
};
//GET IDP REPO
export const getIdpRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_ENGINEERING_API,
    params: params,
  });
};

export const getEngineeringIdpNonPanCollegesRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_ENGINEERING_NONPAN_COLLEGES_API,
    params: params,
  });
};

//POST CLAVERTAP PUSH
export const clavertapPushRepo = (data) => {
  let {origin} = window.location
  return axios({
    baseURL: origin,
    method: "POST",
    url: Urls.PUSH_CLEVERTAP_DATA,
    data: data,
  });
};